var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"related-articles"},[_c('div',{staticClass:"h2"},[_vm._v("RELATED ARTICLES")]),_c('div',{staticClass:"article-row"},[_c('RelatedArticlesItem'),_c('RelatedArticlesItem'),_c('RelatedArticlesItem')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }